export default __webpack_public_path__ + "static/media/menu.7b1957af.svg";